import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import { action, toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import { Button, Popover, Input, Checkbox } from 'antd'
import _get from 'lodash/get'
import _flatten from 'lodash/flatten'

import { ControlSection } from '~/components/styles'
import poisQuery from '~/graphql/queries/pois.gql'
import removePoiMutation from '~/graphql/mutations/removePoi.gql'
import renamePoiMutation from '~/graphql/mutations/renamePoi.gql'

// import user from '~/user.json'

const MAX_PARAMS = 3

@inject('view')
@inject('data')
@inject('user')
// @inject('userPoi')
@graphql(poisQuery, {
  props: ({ data: { loading, pois, refetch } }) => ({
    loading,
    refetch,
    pois: _get(pois, 'nodes', [])
  }),
  options: ({ user: { profile } }) => ({
    variables: {
      userId: profile.userId
    }
  })
})
@graphql(removePoiMutation, {
  props: ({ removePoi, ownProps: { user: { profile } } }) => ({
    removePoi: ({ id }) =>
      removePoi({
        variables: { id },
        update: (store, { data: { removePoi } }) => {
          const data = store.readQuery({ query: poisQuery, variables: { userId: profile.userId, active: true } })
          data.pois.nodes = data.pois.nodes.filter(poi => poi.id !== removePoi.poi.id)
          store.writeQuery({ query: poisQuery, variables: { userId: profile.userId, active: true }, data })
        }
      })
  }),
  name: 'removePoi'
})
@graphql(renamePoiMutation, {
  props: ({ renamePoi, ownProps: { user: { profile } } }) => ({
    renamePoi: ({ id, poiName }) =>
      renamePoi({
        variables: { id, poiName },
        update: (store, { data: { renamePoi } }) => {
          const data = store.readQuery({ query: poisQuery, variables: { userId: profile.userId, active: true } })
          data.pois.nodes.forEach(poi => {
            if (poi.id === renamePoi.poi.id) {
              poi.poiName = renamePoi.poi.poiName
            }
          })
          store.writeQuery({ query: poisQuery, variables: { userId: profile.userId, active: true }, data })
        }
      })
  }),
  name: 'renamePoi'
})
@observer
class StationControl extends Component {
  @action.bound
  handleStationChange (values) {
    // console.log({ value, label })
    const { view } = this.props
    const { poiIds } = view
    const pIds = poiIds ? poiIds.toJS() : []
    if (values.length + pIds.length <= MAX_PARAMS) {
      view.setStationIds(values)
    }
    // console.log({ values })
    // // view.stationId = parseInt(value, 10)
    // if (`${value}`.startsWith('poi')) {
    //   const [, id] = value.split(':')
    //   view.setPoiId(parseInt(id, 10))
    // } else {
    // }
  }
  handlePoiChange = (values) => {
    const { view } = this.props
    const { stationIds } = view
    const sIds = stationIds ? stationIds.toJS() : []
    if (values.length + sIds.length <= MAX_PARAMS) {
      view.setPoiIds(values)
    }
  }
  handleDeletePoiClick = id => e => {
    e.stopPropagation()
    const { data, view } = this.props
    this.props.removePoi({
      id
    }).then(res => {
      const poiId = _get(res, 'data.removePoi.poi.id')
      view.removePoiId(poiId)
      data.removePoi(poiId)
    })
  }
  handleRenamePoi = id => e => {
    this.props.renamePoi({
      id,
      poiName: e.target.value
    })
  }
  render () {
    const { title, view: { stationIds, poiIds }, data: { stations = [], selectedScenarios: $selectedScenarios = [] }, pois } = this.props
    // console.log({ stationIds })
    const sIds = stationIds ? stationIds.toJS() : []
    const pIds = poiIds ? poiIds.toJS() : []

    const selectedScenarios = toJS($selectedScenarios) || [] // TOOO: avoid toJS here
    const scenarioStationPois = _flatten(selectedScenarios.map(scenario => _get(scenario, 'outputs.nodes', [])))
    const scenarioStationIds = scenarioStationPois.filter(sp => !sp.isPoi).map(sp => sp.stationPoiId)
    const scenarioPoiIds = scenarioStationPois.filter(sp => sp.isPoi).map(sp => sp.stationPoiId)
    // console.log({ selectedScenarios, scenarioStationPois, scenarioStationIds })
    // const scIds = scenarioIds ? scenarioIds.toJS() : []

    // console.log({ sIds, stations }, stations.length)
    // const selectedValue = stationId || (poiId && `poi:${poiId}`)
    return <ControlSection>
      {title}
      <Checkbox.Group
        // options={parameters}
        onChange={this.handleStationChange}
        // defaultValue={dataTypes.filter(dt => dt.default).map(dt => `${dt.id}`)}
        value={sIds.map(JSON.stringify)}
      >
        {stations.filter(station => scenarioStationIds.includes(station.id) && station.isResponseData).map(station =>
          <div key={station.id}>
            <Checkbox value={`${station.id}`}>
              {station.stationName}
            </Checkbox>
          </div>
        )}
      </Checkbox.Group>
      <Checkbox.Group
        // options={parameters}
        onChange={this.handlePoiChange}
        value={pIds.map(JSON.stringify)}
        // defaultValue={dataTypes.filter(dt => dt.default).map(dt => `${dt.id}`)}
        // value={stationIds}
      >
        {pois && pois.filter(poi => scenarioPoiIds.includes(poi.id)).map(poi =>
          <div key={poi.id}>
            <Checkbox key={poi.id} value={`${poi.id}`} >
              {poi.poiName}
              <Popover trigger="click" title="rename" content={
                <span>
                  <Input defaultValue={poi.poiName} onPressEnter={this.handleRenamePoi(poi.id)}/>
                </span>
              }>
                <Button icon="edit" shape="circle" size="small" style={{ marginLeft: '.5em' }} />
              </Popover>
              <Button icon="delete" shape="circle" size="small" onClick={this.handleDeletePoiClick(poi.id)} style={{ marginLeft: '.5em' }} />
            </Checkbox>
          </div>
        )}
      </Checkbox.Group>
    </ControlSection>
  }
}

export default StationControl



// WEBPACK FOOTER //
// ./src/modules/Scenario/StationControl.js